import { ArrowRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { scrollToId } from "@/lib/site";

export function Hero() {
  const reduce = useReducedMotion();
  const rise = (d) => ({
    initial: reduce ? { opacity: 1 } : { opacity: 0, y: 22 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: d },
  });

  return (
    <section className="relative min-h-[100svh] flex items-end overflow-hidden bg-[#071426] grain" data-testid="hero-section">
      <img
        src="/img/dubai-hero.jpg"
        alt="Dubai skyline at dusk"
        className="absolute inset-0 h-full w-full object-cover object-center"
        fetchPriority="high"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#071426] via-[#071426]/55 to-[#071426]/20" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#071426]/80 via-[#071426]/30 to-transparent" />

      <div className="relative w-full max-w-6xl mx-auto px-6 sm:px-10 pb-20 sm:pb-28 pt-40">
        <motion.p {...rise(0.1)} className="eyebrow mb-6">Dubai Real Estate · Investor Briefing</motion.p>
        <motion.h1 {...rise(0.2)} className="font-display text-white font-bold text-4xl sm:text-5xl lg:text-6xl xl:text-7xl leading-[1.04] max-w-3xl" data-testid="hero-headline">
          Understand Dubai Real Estate Before You Invest.
        </motion.h1>
        <motion.p {...rise(0.35)} className="mt-6 text-base sm:text-lg text-white/75 max-w-xl leading-relaxed">
          Get clear on the market, explore your options, and understand the questions to ask before making a property investment decision.
        </motion.p>
        <motion.div {...rise(0.5)} className="mt-10 flex flex-col sm:flex-row sm:items-center gap-5">
          <button onClick={() => scrollToId("booking")} className="btn-light" data-testid="hero-book-briefing-button">
            Book Your Free Briefing <ArrowRight size={16} />
          </button>
          <button onClick={() => scrollToId("learn")} className="text-white/85 hover:text-white text-sm font-medium underline-offset-[6px] hover:underline transition-colors self-start sm:self-auto" data-testid="hero-explore-link">
            Explore the Briefing
          </button>
        </motion.div>
        <motion.p {...rise(0.65)} className="mt-8 text-sm text-white/55 flex items-center gap-3" data-testid="hero-reassurance">
          <span className="h-px w-8 bg-[#C7A76C]" />
          Personalized guidance. Clear information. No obligation to buy.
        </motion.p>
      </div>
    </section>
  );
}
